<script lang="ts">
	import Icon from "@components/common/Icon.svelte";
	import chevron from "@core/assets/icons/chevron.svg?raw";
	import type { Breadcrumb } from "@core/schema/Breadcrumb.js";

	const { breadcrumbs }: { breadcrumbs: Breadcrumb[] } = $props();
</script>

{#if breadcrumbs.length > 0}
	<div class="my-8 flex items-center gap-2 overflow-x-auto text-nowrap text-xs/5">
		{#each breadcrumbs as { href, label }, index (index)}
			{#if href}
				<a {href}>{label}</a>
			{:else}
				<span>{label}</span>
			{/if}

			{#if index !== breadcrumbs.length - 1}
				<Icon icon={chevron} square class="w-2" />
			{/if}
		{/each}
	</div>
{/if}
